import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useT } from '../i18n/i18n';

export default function GameRequestPage() {
  const t = useT();
  const [email, setEmail] = useState('');
  const [teaches, setTeaches] = useState('');
  const [details, setDetails] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/requests/game', { method: 'POST', token: true, body: { contactEmail: email.trim(), teaches: teaches.trim(), details: details.trim() } });
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('That did not send. Please try again.'));
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="card">
        <h2>{t('Thank you — your request has been sent')}</h2>
        <p>{t('We will reply to:')} <strong>{email.trim()}</strong>. {t('If it is urgent, you can also email us:')} <a href="mailto:support@fractalon.net">support@fractalon.net</a>.</p>
        <div className="toolbar">
          <Link className="btn" to="/library">{t('Back to the library')}</Link>
          <button type="button" className="btn secondary" onClick={() => { setSent(false); setTeaches(''); setDetails(''); }}>{t('Send another request')}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <h2>{t('Request a custom game')}</h2>
      <p className="field-hint">
        {t('Tell us about a game the library does not have yet. We read every request and will reply to you by email.')}
        {' '}{t('You can also write to us:')} <a href="mailto:support@fractalon.net">support@fractalon.net</a>.
      </p>
      {error && <div className="error" role="alert">{error}</div>}
      <form onSubmit={(e) => void submit(e)}>
        <div className="field">
          <label htmlFor="gr-teaches">{t('What should the game teach?')}</label>
          <input id="gr-teaches" value={teaches} maxLength={500} required placeholder={t('For example: telling the time to the half hour')} onChange={(e) => setTeaches(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="gr-details">{t('How should it work, and anything else we should know')}</label>
          <textarea id="gr-details" rows={6} value={details} maxLength={4000} placeholder={t('What the learner sees and does, the words or pictures to use, and what helps or does not help them.')} onChange={(e) => setDetails(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="gr-email">{t('Email for our reply')}</label>
          <input id="gr-email" type="email" value={email} maxLength={200} required onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="toolbar">
          <button className="btn" type="submit" disabled={busy || !teaches.trim() || !email.trim()}>{busy ? t('Sending…') : t('Send request')}</button>
          <Link className="btn secondary" to="/library">{t('Cancel')}</Link>
        </div>
      </form>
    </div>
  );
}
